export interface TranslatableModelAbstract {
  translations: Array<any>;
}

export function getTranslation(model: TranslatableModelAbstract, localization: string = "bg"): any {
  return model.translations.find(t => t.localization === localization);
}
